import { CustomFontFaceOptions, GoogleFontFaceOptions } from "../popup/types";

export const FONT_FAMILY = "ShopfloPopupFont";

interface FontConfiguration {
  fontType: "google" | "custom";
  googleFontFaces?: GoogleFontFaceOptions[];
  customFontFaces?: CustomFontFaceOptions[];
}

async function loadGoogleFontFace(fontConfiguration: GoogleFontFaceOptions) {
  const font = new FontFace(FONT_FAMILY, `url(${fontConfiguration.src})`, {
    display: "swap",
    style: fontConfiguration.style,
    weight: fontConfiguration.weight.toString(),
    unicodeRange: fontConfiguration.unicodeRange,
  });
  const loadedFont = await font.load();
  document.fonts.add(loadedFont);
}

export async function loadCustomFontFace(
  fontConfiguration: CustomFontFaceOptions
) {
  const font = new FontFace(FONT_FAMILY, `url(${fontConfiguration})`, {
    display: "swap",
  });
  const loadedFont = await font.load();
  document.fonts.add(loadedFont);
}

export async function loadFontFaces(fontConfiguration: FontConfiguration) {
  switch (fontConfiguration.fontType.toLowerCase()) {
    case "google":
      fontConfiguration.googleFontFaces?.forEach(
        (fontFace: GoogleFontFaceOptions) => {
          loadGoogleFontFace(fontFace);
        }
      );
      break;
    case "custom":
      fontConfiguration.customFontFaces?.forEach(
        (fontFace: CustomFontFaceOptions) => {
          loadCustomFontFace(fontFace);
        }
      );
      break;
  }
}
